import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { message } from 'antd';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const errorMsg = action?.payload?.data?.Error?.Message;
    message.error(errorMsg);
  }

  return next(action);
};
